module.exports = __webpack_public_path__ + "img/imgTick.293ecd53.svg";